/// <amd-module name="Feed/Legacy/Protocols/Constants/Constants" />
export class CiConstants {
    public static PersonUrlLinkClicked = "PersonUrlLinkClicked";
    public static PersonEmailLinkClicked = "PersonEmailLinkClicked";
}

export const IvyKey = "ivy";
